// extracted by mini-css-extract-plugin
module.exports = {"addPost":"index_addPost_VPlwx","label":"index_label_2MyVL","submit":"index_submit_3vSLN","editor":"index_editor_1m9JI"};